export const apCategory = {
  STANDARD: 'STANDARD',
  KEY: 'KEY',
};

export const propertySourceType = {
  INTEGRATION: 'INTEGRATION', // Custom Integration
  SALESFORCE: 'SALESFORCE', // Custom Integration
  ENTRATA: 'ENTRATA', // Custom Integration
  PUBLIC_GATEWAY: 'PUBLIC_GATEWAY', // OPEN API
  PLATFORM_GATEWAY: 'PLATFORM_GATEWAY', // CMS or Dashboard
  CMS_FACADE: 'CMS_FACADE', // Legacy
};

export const syncType = {
  OPEN_API: 'open_api',
  INTEGRATION: 'integration',
};

export const propertyFacilityPetFriendly = 'v2_pet_friendly';

export const propertyFacilityTechnologyCategory = [
  'v2_unit_type_wifi',
  'v2_unit_type_television',
  'v2_unit_type_streaming_services',
];

export const propertyFacilityEssentialCategory = [
  'v2_wifi',
  'v2_bike_storage',
  'v2_elevators',
  'v2_wheelchair_accessible',
];

export const propertyFacilityLifestyleCategory = [
  'v2_entertainment_area',
  'v2_cinema',
  'v2_communal_area',
  'v2_streaming_services_in_common_area',
  'v2_gym',
  'v2_yoga_studio',
  'v2_bbq_area',
  'v2_rooftop_terrace',
  'v2_swimming_pool',
  'v2_balcony',
  'v2_basketball_court',
  'v2_outdoor_courtyard',
  'v2_breakfast_bar',
  'v2_skylounge',
  'v2_karaoke',
  'v2_spa',
  'v2_tennis_courts',
];

export const propertyFacilitySharedAreasCategory = [
  'v2_communal_kitchen',
  'v2_shared_bathroom',
  'v2_common_room',
  'v2_games_room',
  'v2_refrigerator',
  'v2_oven',
  'v2_microwave',
  'v2_dishwasher',
];

export const propertyFacilityServicesCategory = [
  'v2_onsite_manager',
  'v2_personal_contents_insurance',
  'v2_reception',
  'v2_shuttle_bus_to_university',
  'v2_library_study_area',
  'v2_post_parcel_collection',
];

export const maxPropertyFetchLimit = 2000;
